'use client';

import {getEnv} from '@config/getEnv';
import {MotionGlobalConfig} from 'framer-motion';
import {FC, PropsWithChildren} from 'react';

MotionGlobalConfig.skipAnimations = getEnv('NEXT_PUBLIC_E2E') === 'true';

export const FramerMotionConfigProvider: FC<PropsWithChildren> = ({
    children,
}) => {
    return <>{children}</>;
};
